import axios from '../utils/axios';

export default function getSeekerFollowUpHistory(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/followup`, { params });
};
